import { ChangeEvent, CSSProperties, KeyboardEvent, useEffect, useState } from 'react';
import Label from './Label';

interface NumberInputProps {
    value?: number,
    label?: string,
    placeholder?: string,
    required?: boolean,
    disabled?: boolean,
    min?: number,
    max?: number,
    setValue?: (value: number) => void,
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void,
    onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void,
    'data-test-id'?: string,
    containerStyle?: CSSProperties,
    children?: React.ReactNode,
}

function NumberInput({ value, label, placeholder, required, disabled, onChange, onKeyDown, setValue, min, max, containerStyle, children, 'data-test-id': testId }: NumberInputProps) {
    const [localValue, setLocalValue] = useState(value?.toString() || '');

    useEffect(() => {
        setLocalValue(value?.toString() || '');
    }, [value]);

    return <p className="form__item" style={containerStyle}>
        {label && <Label>{label}</Label>}
        <input
            type="number"
            onSelect={(e) => e.preventDefault()}
            className="form__input"
            required={required}
            value={localValue}
            placeholder={placeholder}
            disabled={disabled}
            onChange={(e) => {
                let val = Number(e.target.value);
                if (min !== undefined) {
                    val = val < min ? min : val;
                }
                if (max !== undefined) {
                    val = val > max ? max : val;
                }
                setLocalValue(val.toString());
                onChange && onChange(e);
                setValue && setValue(val);
            }}
            onKeyDown={onKeyDown}
            data-test-id={testId}
        />
        {children}
    </p>
}

export default NumberInput;